"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Container = function Container(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ui-container ".concat(className)
  }, children);
};

Container.defaultProps = {
  className: ''
};
Container.propTypes = {
  /** Child content rendered inside Container. */
  children: _propTypes.default.node,

  /** Custom class name added to Container. */
  className: _propTypes.default.string
};
var _default = Container;
exports.default = _default;
//# sourceMappingURL=Container.js.map